import { render, staticRenderFns } from "./GroupSetting.vue?vue&type=template&id=498bca80&"
import script from "./GroupSetting.vue?vue&type=script&lang=js&"
export * from "./GroupSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('498bca80')) {
      api.createRecord('498bca80', component.options)
    } else {
      api.reload('498bca80', component.options)
    }
    module.hot.accept("./GroupSetting.vue?vue&type=template&id=498bca80&", function () {
      api.rerender('498bca80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Device/GroupSetting.vue"
export default component.exports